














































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { validateLegacyUser } from "@/services/security/authService";
import { LegacyLoginDtoIn, ValidateLegacyLoginDto } from "@/services/security/types";
import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/app.config";
const namespace: string = "authentication";

@Component
export default class Login extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;

    processingLogin = false;
    failedLogin = false;
    authUser: LegacyLoginDtoIn = {
        userName: "",
        password: ""
    };

    onLogin(): void {
        this.processingLogin = true;
        this.failedLogin = false;

        validateLegacyUser(this.authUser)
            .then((response: ValidateLegacyLoginDto) => {
                if (response.validated) {
                    if (!response.isSharedUser) {
                        this.$router.push({
                            name: "IsSharedAccount",
                            params: {
                                legacyUser: JSON.stringify(this.authUser)
                            }
                        });
                    } else {
                        this.$router.push({
                            name: "SharedAccount",
                            params: {
                                legacyUser: JSON.stringify(this.authUser)
                            }
                        });
                    }
                } else {
                    this.failedLogin = true;
                }
            })
            .catch((reason: any) => {
                this.failedLogin = true;
            });
    }

    inputModified(): void {
        this.failedLogin = false;
    }

    setLocale(): void {
        const languageCode: string = this.getCurrentUser.cultureCode;
        i18n.locale = languageCode || FALLBACK_LOCALE;
    }
}
